/* Shared by both ABlyft variants; assignment belongs to ABlyft. */
(() => {
  if (window.solagoFilterAB) return;

  const attribute = 'data-solago-filter-variant';
  const root = document.documentElement;
  const legacy = 'filter.p.m.custom.battery_storage_filter_cp';
  const modern = [
    'filter.p.m.custom.filter_speicher',
    'filter.p.m.custom.filter_leistung',
    'filter.p.m.custom.filter_speichersystem',
    'filter.p.m.custom.filter_montageort'
  ];
  const variant = () => root.getAttribute(attribute) === 'b' ? 'b' : 'a';
  const cleanUrl = (value, selected = variant()) => {
    const url = new URL(value, location.href);
    const inactive = selected === 'b' ? [legacy] : modern;
    let changed = false;
    inactive.forEach((name) => {
      if (url.searchParams.has(name)) {
        url.searchParams.delete(name);
        changed = true;
      }
    });
    if (changed) url.searchParams.delete('page');
    return url;
  };

  window.solagoFilterAB = { cleanUrl };

  // Capture runs before the theme's product-facet listener and its AJAX request.
  document.addEventListener('facet:criteria-changed', (event) => {
    if (!event.target.closest?.('product-facet') || !event.detail?.url) return;
    event.detail.url = cleanUrl(event.detail.url).href;
  }, true);
  document.addEventListener('pagination:page-changed', (event) => {
    if (!event.target.closest?.('product-facet') || !event.detail?.url) return;
    event.detail.url = cleanUrl(event.detail.url).href;
  }, true);

  const syncInputs = () => {
    document.querySelectorAll('product-facet [data-filter-ab-variant] input').forEach((input) => {
      const owner = input.closest('[data-filter-ab-variant]');
      const hidden = owner.dataset.filterAbVariant !== variant();
      if (hidden && !input.disabled) {
        input.dataset.abDisabled = 'true';
        input.disabled = true;
      } else if (!hidden && input.dataset.abDisabled === 'true') {
        input.disabled = false;
        delete input.dataset.abDisabled;
      }
    });
  };

  const normalizeSelection = () => {
    syncInputs();
    // Wait for an explicit assignment. A delayed ABlyft snippet must not have
    // its B deep-link parameters removed while A is only the visual fallback.
    if (!root.hasAttribute(attribute)) return;
    const facet = document.querySelector('product-facet');
    if (!facet) return;
    const url = cleanUrl(location.href);
    if (url.href !== location.href) {
      customElements.whenDefined('product-facet').then(() => {
        const current = cleanUrl(location.href);
        if (current.href !== location.href && facet.isConnected) {
          facet.dispatchEvent(new CustomEvent('facet:criteria-changed', {
            bubbles: true,
            detail: { url: current.href }
          }));
        }
      });
    }
  };

  new MutationObserver(normalizeSelection).observe(root, {
    attributes: true,
    attributeFilter: [attribute]
  });

  // The theme replaces the filter form and product markup after each request.
  // Reapply disabled states so hidden inputs cannot enter FormData.
  const start = () => {
    document.querySelectorAll('product-facet').forEach((facet) => {
      new MutationObserver(syncInputs).observe(facet, { childList: true, subtree: true });
    });
    normalizeSelection();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
